module.exports = __webpack_public_path__ + "static/media/img13.23cb0bd5.jpg";